import { User } from "../types/user";

class TokenService {
    getLocalAccessToken() {
      return JSON.parse(localStorage.getItem("user") ?? "null")?.token;
    }
  
    getUser() {
      return JSON.parse(localStorage.getItem("user") ?? "null")?.data;
    }
  
    setUser(user: User, token: string) {
      localStorage.setItem("user", JSON.stringify({ data: user, token: token }));
    }
  
    removeUser() {
      localStorage.removeItem("user");
    }
}

const Token = new TokenService();

export default Token;
